const url = 'https://www.wrike.com/form/eyJhY2NvdW50SWQiOjI0Mjk1ODQsInRhc2tGb3JtSWQiOjM2NDg3OX0JNDc1MTQzNTk2NzkxNwkyOGM5N2JlMGZjYWE5MzQ3N2RkNTViNzVhNjE2N2JmMGZiYzM4NWM2YzEzMzk5MzY3ZDBmMmE1MGFiNGRlODIx';

export default url;
